import React, { useState, createContext } from 'react';

const SdoApiErrorContext = createContext({ sdoError: 0, setSdoErrorCode: (statusCode) => {} } );

export const SdoApiErrorProvider = (props) => {
    const [sdoError, setSdoError] = useState(0);

    const setSdoErrorCode = (statusCode) => {
      if(sdoError) {
        return;
      }
      setSdoError(statusCode);
    }
    
  
    return (
      <SdoApiErrorContext.Provider value={{ sdoError, setSdoErrorCode }} >
        {props.children}
      </SdoApiErrorContext.Provider>
    );
  }
  
  export const useSdoApiError = () => {
    const context = React.useContext(SdoApiErrorContext);
    return context;
  }